import { Component, OnInit } from '@angular/core';
import { GuidedTour, GuidedTourService, Orientation } from 'ngx-guided-tour';
 
@Component({
  selector: 'app-core-container',
  templateUrl: './core-container.component.html',
  styleUrls: ['./core-container.component.scss']
})
export class CoreContainerComponent implements OnInit {
  public dashboardTour: GuidedTour = {
    tourId: 'purchases-tour2',
    useOrb: true,
    steps: [
        {
            title: 'Stg Drive Guide',
            selector: '.demo-title',
            content: 'Bienvenue dans la démonstration de la plateforme Stg Drive Partie Administration',
            orientation: Orientation.Right
        },
         
        {
            title: 'Gestion des boitiers',
            selector: '.boitier',
            content: 'Accéder au gestionnaire de boitiers',
            orientation: Orientation.Right,
         
        },
      {
        title: 'Gestion des Boitier',
        selector: '.boitierRefrechAll',
        content: 'Actualiser les messages entrants et la liste des véhicules',
        orientation: Orientation.Right
    }
    ,
      {
        title: 'Gestion des Boitier',
        selector: '.BoitierRefrechVehicule',
        content: 'Actualiser la liste des véhicule',
        orientation: Orientation.Left
    }
    ,
    {
      title: 'Gestion des Boitier',
      selector: '.BoitierDateSelect',
      content: 'Valider le filtrage par date',
      orientation: Orientation.Right
  },
   
{
  title: 'Gestion des Boitier',
  selector: '.BoitierInformations',
  content: ' Informations Boîtiers ',
  orientation: Orientation.Right
}
,
{
  title: 'Gestion des Boitier',
  selector: '.BoitierCalibration',
  content: ' Statut de calibration ',
  orientation: Orientation.Right,
  

},
{
  title: 'test',
  selector: '.test',
  content: ' test',
  orientation: Orientation.Right
}
,
        {
            title: 'Compagnies',
            selector: '.compagnie',
            content: 'Gérez vos compagnies',
            orientation: Orientation.Right
        },
        {
            title: 'Véhicules',
            selector: '.vehicule',
            content: 'Gérez les véhicles de vos companies',
            orientation: Orientation.Right
        },
        {
          title: 'Conducteurs',
          selector: '.conducteur',
          content: 'Gérez les conducteurs de vos compagnies',
          orientation: Orientation.Right
      },
      {
        title: 'Utilisateurs',
        selector: '.utilisateur',
        content: 'Gérez vos utilisateurs',
        orientation: Orientation.Right
    },
    {
      title: 'Se déconnecter',
      selector: '.deconnecter',
      content: 'Se déconnecter de Stg Drive',
      orientation: Orientation.Top
  }

    ]
};

  constructor(private guidedTourService: GuidedTourService) {   setTimeout(() => {
    this.guidedTourService.startTour(this.dashboardTour);
}, 1000);}

 
  ngOnInit(): void {
  }
  public restartTour(): void {
    this.guidedTourService.startTour(this.dashboardTour);
}
}
